import React from 'react';

const Payment = () => {
    return (
        <div>
            <h1 className='m-5 text-info'>Payment Option comming son.</h1>
        </div>
    );
};

export default Payment;